<template>
    <div id="diverTripStatusPage">
        <div id="driverTripStatusContent">
            <div id="driverTripStatusTitle">
                Driver's Trip Status
            </div>
            <div class="driverTripStatusDiv" v-if="trips.length > 0">
                <div v-if="!trip" class="errorMessage">
                    You are NOT currently assigned to any trips.
                </div>
                <div v-else-if="tripIsActive && youAreTheDriver" class="tripInfoAndAction">
                    <div id="driverTripVehicleInfo">
                        <span>
                            {{ vehicle ? vehicle.stock_number : this.trip.stock_num }}
                        </span> 
                        <div id="tripVehicleInfo">
                            <span v-if="vehicle">
                                {{ vehicle.year }}&nbsp;
                            </span>
                            <span v-if="vehicle">
                                {{ vehicle.make }}&nbsp;
                            </span>
                            <span v-if="vehicle">
                                {{ vehicle.model }}
                            </span>
                        </div>
                        <img v-if="vehicle" id="tripVehicleImage" :src="vehicle.primary_img"/>
                        <span v-if="skipWash" class="driverAttention">
                            Skip Wash
                        </span>
                    </div>
                    <div id="driverTripInfo">
                        <div id="tripCreationInfo">
                            {{ this.tripFrom.name }} to {{ this.tripTo.name }}
                            <div v-if="tripHasNotes">
                                <ul>
                                    <li v-for="note in this.trip.notes" :key="note.id">
                                        {{ note.note }}
                                    </li>
                                </ul>
                            </div>
                        </div> 
                        <div id="deliverToInfo">
                            <div>
                                Deliver To:
                            </div>
                            <user :user="getProductSpecialist" :modified="false" :mode="null" :phoneHyperlink="true"/>
                        </div>
                    </div>
                    <div v-show="!delayInitiated" id="driverTripStatusActions"> 
                        <trip-action :trip="trip" :tripAction="{stage: 2, displayText: 'Left ' + tripFrom.name}"/>
                        <trip-action :trip="trip" :tripAction="{stage: 3, displayText: 'Arrived at ' + tripTo.name}"/>
                        <div v-show="driverArrived">
                            Vehicle was delivered to:
                            <div :id="getProductSpecialist.id" class="diliveredToUser" @click="setDeliveredTo(getProductSpecialist.id)" :class="[!deliveredTo ? '' : deliveredTo == getProductSpecialist.id ? 'selected' : 'notSelected', 'deliveredToButton']">
                                <user :user="getProductSpecialist" :modified="false" :mode="null" :phoneHyperlink="true"/>
                                <div id="preferredReciever">
                                    Preferred
                                </div>
                            </div>
                            <div :id="getManager.id" class="diliveredToUser" @click="setDeliveredTo(getManager.id)" :class="[!deliveredTo ? '' : deliveredTo == getManager.id ? 'selected' : 'notSelected', 'deliveredToButton']">
                                <user :user="getManager" :modified="false" :mode="null"  :phoneHyperlink="true"/>
                                <div id="backupReciever">
                                    Backup
                                </div>
                            </div>
                            <div :id="getManager.id" class="diliveredToUser" @click="setDeliveredTo('Front Desk')" :class="[!deliveredTo ? '' : deliveredTo == 'Front Desk' ? 'selected' : 'notSelected', 'deliveredToButton']">
                                <div id="backupReciever">
                                    Font Desk
                                </div>
                            </div>
                            <div>
                                Someone Else:
                                <v-input name="delivered_to" type="text" @change="setDeliveredTo($event)"/>
                            </div>
                        </div>
                        <trip-action :trip="trip" :tripAction="{stage: 4, displayText: 'Delivered Keys', options: {delivered_to: deliveredTo}}"/>
                        <trip-action v-if="vehicleDelivered" :trip="trip" :tripAction="{stage: 5, displayText: 'Complete Trip', options: {delivered: getNow}}"/>
                        <div v-show="trip.transit_action_stage < 3" id="selectDelayButton" @click="beginDelay">
                            <div id="delayText">
                                Delayed
                            </div>
                            <i id="delayCaution" class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                        </div>
                    </div>
                    <div id="driverTripDelays" v-if="delayInitiated">
                        <div id="selectDelayButton" @click="endDelay">
                            <i id="returnFromDelayOptions" class="fa fa-chevron-left" aria-hidden="true"></i> 
                            <div id="delayText">
                                Delayed
                            </div>
                            <i id="delayCaution" class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                        </div>
                        <delay-display :tripId="trip.id"/>
                    </div>
                </div>
                <div v-else-if="!tripIsActive" class="errorMessage">
                    This trip is no longer active.
                </div>
                <div v-else-if="!driverIsAssigned" class="errorMessage">
                    A driver has not been assigned to this trip.
                </div>
                <div v-else class="sorryMessage errorMessage">
                    <span>
                        You are logged in as:
                    </span>
                    <user :user="$privateReactiveStore.getUser()" :modified="false" :mode="null"/>
                    <span>
                        You are not the assigned driver for this trip. 
                    </span>
                </div>
            </div>
            <div v-else class="driverTripStatusDiv spinner"> 
                <div :class="[showSpinner ? 'appear' : '', 'mediaLoadingSpinnerWrapper']" v-show="showSpinner">
                    <div :class="[showSpinner ? 'appear' : '', 'mediaLoadingSpinner']"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import User from '../custom-components/User.vue'
    import TripAction from '../custom-components/TripAction.vue'
    import DelayDisplay from '../custom-components/DelayDisplay.vue'
    import epoch from 'epoch.js'

    export default {
        data() {
            return {
                vehicle: null,
                deliveredTo: '',
                delayInitiated: false,
            }
        },
        props: [
            'tripId'
        ],
        mounted() {
            this.$eventHub.$on('vehicleWithPrimaryImage', this.setVehicle);
            this.$eventHub.$on('cancleDelay', this.endDelay);
            this.$eventHub.$on('completeDelay', this.completeDelay);
        },
        updated() {
            if(!this.vehicle || this.vehicle.stock_number != this.trip.stock_num) {
                this.requestVehicle();
            }
        },
        destroyed() {
            this.$eventHub.$off('vehicleWithPrimaryImage');
            this.$eventHub.$off('cancleDelay');
        },
        components: {
            'user': User,
            'trip-action': TripAction,
            'delay-display': DelayDisplay
        },
        computed: {
            trips() {
                return this.$privateReactiveStore.getTrips();
            },
            trip() {
                console.log("GETTING TRIP " + this.tripId);
                if(this.tripId) {
                    return this.$privateReactiveStore.getTrip(this.tripId);
                }
                else {
                    return null;
                }
            },
            tripIsActive() {
                return this.trip.delivered || this.$privateReactiveStore.isTripStillActive(this.tripId);
            },
            tripFrom() {
                return this.$privateReactiveStore.getLocation(this.trip.from);
            },
            tripTo() {
                return this.$privateReactiveStore.getLocation(this.trip.to);
            },
            tripHasNotes() {
                return this.trip.notes && this.trip.notes.length > 0;
            },
            driver() {
                return this.trip.drivers && this.trip.drivers.length > 0 ? this.trip.drivers[0] : null;
            },
            driverIsAssigned() {
                return this.driver != null;
            },
            youAreTheDriver() {
                return this.driver ? this.$privateReactiveStore.getUser().id == this.driver.id : false;
            },
            skipWash() {
                return this.trip.skip_wash;
            },
            driverArrived() {
                return this.trip.transit_action_stage == 3;//this.trip.transit_status == "driver_arrived" || this.trip.transit_status_stage == 3;
            },
            vehicleDelivered() {
                return (this.trip.delivered || this.trip.transit_action_stage >= 4);
            },
            productSpecialists() {
                return this.$privateReactiveStore.getProductSpecialists();
            },
            getManager() {
                return this.$privateReactiveStore.getManager(this.trip.mgr_requested);
            },
            getProductSpecialist() {
                return this.$privateReactiveStore.getProductSpecialist(this.trip.product_specialist);
            },
            showSpinner() {
                return this.trips.length > 0;
            },
            getNow() {
                return epoch().datetime();
            }
        },
        methods: {
            requestVehicle() {
                return this.$eventHub.$emit('getTripVehicle', this.trip.stock_num);
            },
            setVehicle(vehicleWithPrimaryImg) {
                this.vehicle = vehicleWithPrimaryImg;
            },
            setDeliveredTo(keysWith) {
                this.deliveredTo = keysWith;
            },
            beginDelay() {
                this.delayInitiated = true;
            },
            endDelay() {
                this.delayInitiated = false;
                let tripDelayUpdate = {transit_delay_id: null, transit_delay_time: null};
                
                this.$eventHub.$emit('updateTrip', this.trip.id, tripDelayUpdate);
            },
            completeDelay() {
                this.delayInitiated = false;;
            }
        }
    }
</script>

<style scoped>
    .driverAttention {
        color: red;
        font-weight: bold;
    }

    #diverTripStatusPage {
        width: 100vw;
        height: 100vh;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    #driverTripStatusContent {
        max-width: 320px;
        width: 90vw;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    #driverTripStatusTitle {
        height: 8vh;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: bolder;
        font-size: 1.75em;
    }

    .driverTripStatusDiv {
        height: 92vh;
        width: 100%;
    }

    .driverTripSatusDiv.spinner {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    #driverTripVehicleInfo {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    #tripVehicleInfo {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
    }

    #tripVehicleImage {
        width: 50%;
    }

    #driverTripInfo {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-around
    }

    .errorMessage {
        display: flex;
        height: 100%;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    #driverTripStatusActions {
        height: 60vh;
        display: flex;
        flex-direction: column;
        justify-content: start;
        align-items: center;
    }

    #selectDelayButton {
        display: flex;
        width: 100%;
        align-items: center;
        justify-content: flex-end;
        border-radius: 1vw;
        padding: 1.25vh 0;
        margin: .4vh 0;
        font-style: normal;
        font-weight: bold;
        background-color: #fce303;
        border-top: solid thick #fcf6bb;
        border-left: solid thick #fcf6bb;
        border-right: solid thick #bab58a;
        border-bottom: solid thick #bab58a;
    }

    #delayCaution {
        color: orange;
        width: 20%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    #returnFromDelayOptions {
        color: orange;
        width: 20%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    #delayText {
        width: 60%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .tripInfoAndAction {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        height: 100%;
    }

    .deliveredToButton {
        display: flex;
        flex-direction: column;
        width: 100%;
        align-items: center;
        justify-content: center;
        border-radius: 1vw;
        padding: 1.25vh 0;
        margin: .4vh 0;
        border: solid thin blue;
    }

    .deliveredToButton.selected {
        background-color: gold;
    }

    .deliveredToButton.notSelected {
        border-color: grey
    }

    #tripCreationInfo {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    #tripCreationInfo ul {
        list-style-position: inside;
        padding-left: 0;
        margin: 0vh 0vh;
        width: 100%;
    }

    #preferredReciever {
        font-weight: bolder;
    }

    #driverTripDelays {
        height: 60vh;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    
    .mediaLoadingSpinnerWrapper {
        position: absolute;
        height: 5vh;
        width: 5vh;
        background-color: transparent;
        z-index: 10;
        opacity: 0;
        transition: opacity 1s;
        left: calc(50% - 2.5vh);
        bottom: 0;
    }

    .mediaLoadingSpinnerWrapper.appear {
        opacity: .8;
    }

    .mediaLoadingSpinner {
        margin: .25vh;
        border: 3px solid rgb(172,179,183);
        border-radius: 50%;
        border-top: 3px solid #207BD3;
        width: 4.5vh;
        height: 4.5vh;
        -webkit-animation: spin 3s linear infinite;
        animation: spin 3s linear infinite;
        opacity: 0;
        -webkit-transition: opacity 1s;
        -moz-transition: opacity 1s;     
        transition: opacity 1s;
    }

    .mediaLoadingSpinner.appear {
        opacity: 1;
    }
    
    @-webkit-keyframes spin {
        0% { -webkit-transform: rotate(0deg); }
        100% { -webkit-transform: rotate(360deg); }
    }
    
    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
</style>